import {Component, PanelLifecycleContext} from 'panel';

import {commonTrackingEventPropertyName} from 'common/report/tracking-setup';
import {Subscribable} from 'common/types/context/subscribable';

import {ReportLayout, ScrollMode} from './types';

export class ReportLayoutManager implements PanelLifecycleContext, Subscribable {
  private connectedComponents: Set<Component<any>> = new Set();
  private _reportLayout: ReportLayout = ReportLayout.SplitChartTable;
  private _scrollMode: ScrollMode = null;
  private subscriptions = [];

  subscribe(callback: () => void): this {
    this.subscriptions.push(callback);
    return this;
  }
  unsubscribe(callback: () => void): this {
    this.subscriptions = this.subscriptions.filter((cb) => cb !== callback);
    return this;
  }
  resetReportLayoutIfNeeded({hasDataTable}: {hasDataTable: boolean}) {
    const newReportLayout = hasDataTable ? ReportLayout.SplitChartTable : ReportLayout.NonSplit;
    if (newReportLayout === this._reportLayout) {
      return;
    }
    this.updateReportLayout(newReportLayout);
  }

  updateReportLayout(reportLayout: ReportLayout) {
    this._reportLayout = reportLayout;
    this.updateComponents();
  }

  getReportLayout() {
    return this._reportLayout;
  }

  updateScrollMode(scrollMode: ScrollMode) {
    this._scrollMode = scrollMode;
    this.updateComponents();
  }

  getScrollMode(): ScrollMode {
    return this._scrollMode;
  }

  hasFixedSizeChart() {
    return this._reportLayout === ReportLayout.SplitChartTable && this._scrollMode === ScrollMode.PageScroll;
  }

  getTrackingProps() {
    return {
      [commonTrackingEventPropertyName.reportLayout]: this._reportLayout,
      [commonTrackingEventPropertyName.reportScrollMode]: this._scrollMode,
    };
  }

  public bindToComponent(component: Component<any, any, any, any, any>): void {
    this.connectedComponents.add(component);
  }

  public unbindFromComponent(component: Component<any, any, any, any, any>): void {
    this.connectedComponents.delete(component);
  }

  private updateComponents() {
    for (const component of this.connectedComponents) {
      component.update();
    }
    for (const subscription of this.subscriptions) {
      subscription();
    }
  }
}
